import {
  ApplicationRef,
  Injectable,
  Injector,
  ComponentRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { ToastComponent } from '../components/common/toast/toast.component';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private viewContainerRef!: ViewContainerRef;

  constructor(private appRef: ApplicationRef, private injector: Injector) {}

  /**
   * Call this once in the app root to set where to render the toast
   */
  registerViewContainerRef(viewContainerRef: ViewContainerRef) {
    this.viewContainerRef = viewContainerRef;
  }

  show(message: string, type: 'success' | 'error' = 'success') {
    if (!this.viewContainerRef) {
      console.error('ToastService: viewContainerRef not set.');
      return;
    }

    const componentRef: ComponentRef<ToastComponent> =
      this.viewContainerRef.createComponent(ToastComponent, {
        injector: this.injector,
      });

    componentRef.instance.message = message;
    componentRef.instance.type = type;

    // Automatically remove the toast after 3 seconds
    setTimeout(() => {
      componentRef.destroy();
    }, 5000);
  }
}
